/**
 * Pre-computed trigonometric lookup tables.
 *
 * This is the ONLY file permitted to use Math.sin / Math.cos directly.
 * All other code must use lookupSin / lookupCos from this module.
 */

/** Resolution in radians per table entry */
export const RESOLUTION = 0.001;

/** Number of entries: ceil(2π / RESOLUTION) */
export const TABLE_SIZE = Math.ceil(2 * Math.PI / RESOLUTION); // 6284

/** Pre-computed sine table */
export const SIN_TABLE = new Float64Array(TABLE_SIZE);

/** Pre-computed cosine table */
export const COS_TABLE = new Float64Array(TABLE_SIZE);

// Populate tables at module load time
for (let i = 0; i < TABLE_SIZE; i++) {
  const rad = i * RESOLUTION;
  SIN_TABLE[i] = Math.sin(rad);
  COS_TABLE[i] = Math.cos(rad);
}

const TWO_PI = 2 * Math.PI;

function toIndex(radians: number): number {
  // Normalize to [0, 2π) in floating point first, then convert to index
  const normalized = ((radians % TWO_PI) + TWO_PI) % TWO_PI;
  const idx = Math.round(normalized / RESOLUTION);
  // Clamp to valid range (idx could equal TABLE_SIZE due to rounding at the boundary)
  return idx >= TABLE_SIZE ? 0 : idx;
}

/** Look up sine of an angle in radians (nearest-neighbor, handles negatives and wrapping) */
export function lookupSin(radians: number): number {
  return SIN_TABLE[toIndex(radians)]!;
}

/** Look up cosine of an angle in radians (nearest-neighbor, handles negatives and wrapping) */
export function lookupCos(radians: number): number {
  return COS_TABLE[toIndex(radians)]!;
}
